// extracted by mini-css-extract-plugin
export default {"heading":"k6PfCIogCG3D1EjIbnJc"};